export default __webpack_public_path__ + "static/media/012-observatory.17437ba0.svg";